export const ASSISTIMO_ICON_SRC = "/proptimo-icon-gradient.svg";
